import { _ } from '/@/locale';

export const getSoilTextures = (state) => state.carbonCalculatorBR.soilTextures;

export const getSelectedSoilTexture = (state) => state.carbonCalculatorBR.selectedSoilTexture;

export const getSoilTexturesOptions = (state) => {
    const soilTextures = getSoilTextures(state);
    return soilTextures.map((soilTexture) => ({
        value: soilTexture.id,
        label: soilTexture.texture,
    }));
};

export const getCrops = (state) => state.carbonCalculatorBR.crops;

export const getCropOptions = (state) => {
    const crops = getCrops(state);
    return crops.map((crop) => ({
        value: crop.id,
        label: crop.cropName,
    }));
};

export const getCropWinterOptions = (state) => {
    const crops = getCrops(state);
    const winterOptions = crops.filter(
        (crop) => crop.season === 'CP-I' || crop.season === 'CC-I' || crop.season === '#Pousio'
    );

    return winterOptions.map((winterOption) => ({
        value: winterOption.id,
        label: winterOption.cropName,
    }));
};

export const getCropSummerOptions = (state) => {
    const crops = getCrops(state);
    const summerOptions = crops.filter(
        (crop) => crop.season === 'CP-V' || crop.season === 'CC-V' || crop.season === '#Pousio'
    );

    return summerOptions.map((summerOption) => ({
        value: summerOption.id,
        label: summerOption.cropName,
    }));
};

export const getCropRotation = (state) => [
    {
        value: 1,
        label: _('Sí'),
    },
    {
        value: 0,
        label: _('No'),
    },
];

export const getCropRotationSelected = (state) => state.carbonCalculatorBR.cropRotationSelected;

export const getAgriculturalPractice = (state) => state.carbonCalculatorBR.agriculturalPractice;
export const getAgriculturalPracticeOptions = (state) => {
    const agriculturalPractice = getAgriculturalPractice(state);
    agriculturalPractice.sort((a, b) => {
        (a = a.practice.toLowerCase()), (b = b.practice.toLowerCase());

        if (a < b) {
            return -1;
        }
        if (a > b) {
            return 1;
        }
        return 0;
    });
    return agriculturalPractice.map((practice) => ({
        value: practice.id,
        label: practice.practice,
    }));
};
